import { render, staticRenderFns } from "./UserProfileWidget.vue?vue&type=template&id=320f5a80&"
import script from "./UserProfileWidget.vue?vue&type=script&lang=js&"
export * from "./UserProfileWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports